import { deviceHeartBeatDataReport, getCommonParams } from '@/common/api/omReport'
import timeoutWorker from '../timeoutWorker'
import { loganLog } from '@RootCommon/utils/logan'
import { owlReportMetricsWeb } from '@RootCommon/utils/owl'
import { getLoginShopid } from '@RootCommon/utils'

// const DEFAULT_REPORT_GAP_TIME = 10 * 60 * 1000 // test：兜底10min上报一次
const DEFAULT_REPORT_GAP_TIME = 60 * 60 * 1000 // 兜底1小时上报一次

let startDeviceHeartBeatTime = 0 // 记录开始心跳上报的时间
const reportResult: {
  startTime: number // 发起心跳上报的时间戳
  responseTime: number // 请求耗时
  status: 'success' | 'failed'
}[] = [] // 记录发起每次心跳上报的时间戳、请求状态、耗时
let totalRequests = 0 // 心跳总次数
let failedRequests = 0 // 心跳失败次数

export function addHeartBeatData (startTime: number, responseTime: number, isFailed: boolean) {
  if (startDeviceHeartBeatTime === 0) {
    startDeviceHeartBeatTime = startTime
  }
  reportResult.push({
    startTime,
    responseTime,
    status: isFailed ? 'failed' : 'success',
  })
  totalRequests++
  if (isFailed) {
    failedRequests++
  }
}

/**
 * 需要重置心跳数据场景：
 * 1. 再次发起心跳上报时
 * 2. 页面关闭时
 * 3. 切换门店时
 */
export function resetHeartBeatData () {
  startDeviceHeartBeatTime = 0
  reportResult.length = 0
  totalRequests = 0
  failedRequests = 0
}

function getHeartReportInfo () {
  const sortedResponseTimes = [...reportResult.map(item => item.responseTime)].sort((a, b) => a - b)
  const responseTimesLen = sortedResponseTimes.length
  const tp50 = responseTimesLen ? sortedResponseTimes[Math.floor(responseTimesLen * 0.5)] : 0
  const tp90 = responseTimesLen ? sortedResponseTimes[Math.floor(responseTimesLen * 0.9)] : 0
  const tp99 = responseTimesLen ? sortedResponseTimes[Math.floor(responseTimesLen * 0.99)] : 0

  const heartReportInfo = {
    periodCost: startDeviceHeartBeatTime ? Date.now() - startDeviceHeartBeatTime : 0,
    total: totalRequests,
    failed: failedRequests,
    tp50,
    tp90,
    tp99,
    reportResult,
  }
  return heartReportInfo
}

export function reportDeviceHeartBeatData (deviceType: number, isFirstCall = true, isOnlyReportOnce) {
  const shopId = getLoginShopid()
  if (shopId <= 0) {
    return
  }

  const executeReport = async () => {
    const heartReportInfo = getHeartReportInfo()
    // raptor上报 - 心跳数据统计触发数
    owlReportMetricsWeb({ 'device_heart_beat_data_report_trigger': 1 })
    loganLog({ msg: '心跳数据统计触发', shopId, heartReportInfo, passedMinutes: Math.floor(heartReportInfo.periodCost / (60 * 1000)) })
    // raptor上报 - 截止本次上报，心跳触发次数
    owlReportMetricsWeb({ 'heartbeat_count': heartReportInfo.total })
    // raptor上报 - 截止本次上报，过去的分钟数
    owlReportMetricsWeb({ 'heartbeat_minutes': Math.floor(heartReportInfo.periodCost / (60 * 1000)) })
    let reportGapTime = DEFAULT_REPORT_GAP_TIME
    if (!isFirstCall) {
      try {
        const res = await deviceHeartBeatDataReport(deviceType, heartReportInfo)
        reportGapTime = res.reportGapTime ? res.reportGapTime * 1000 : DEFAULT_REPORT_GAP_TIME
        // raptor上报 - 心跳数据统计成功数
        owlReportMetricsWeb({ 'device_heart_beat_data_report_success': 1 })
        loganLog({ msg: '心跳上报统计数据成功', shopId, heartReportInfo, passedMinutes: Math.floor(heartReportInfo.periodCost / (60 * 1000)) })
        resetHeartBeatData()
      } catch (e) {
        // raptor上报 - 心跳数据统计失败数
        owlReportMetricsWeb({ 'device_heart_beat_data_report_error': 1 })
        loganLog({ msg: '心跳数据统计接口调用失败', error: JSON.stringify(e) })
      }
    }

    if (!isOnlyReportOnce) {
      timeoutWorker.setTimeout(reportGapTime, () => {
        reportDeviceHeartBeatData(deviceType, false, isOnlyReportOnce)
      })
    }
  }

  executeReport()
}

export function reportDeviceHeartBeatDataBeforeUnload () {
  const shopId = getLoginShopid()
  if (shopId <= 0) {
    return
  }

  // 页面关闭前发送一次上报
  const heartReportInfo = getHeartReportInfo()
  loganLog({ msg: '页面关闭前sendBeacon发送心跳数据上报', shopId, heartReportInfo })

  navigator.sendBeacon(
    '/api/operate/device/heartbeatDataReport',
    JSON.stringify({
      ...getCommonParams(),
      heartReportInfo: JSON.stringify(heartReportInfo),
    }),
  )
  resetHeartBeatData()
}
